(function () {
	'use strict';

    angular.module("imApp").factory("consignmentPlansDeliveryDriverService", ['$ihttp', function ($ihttp) {
		let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1716,
                    parameters: parms || {}
                });
            },
            listDeliveryMethods: function (parms) {
                return $ihttp.post({
                    method: 1693,
                    parameters: parms || {}
                });
            },
            updateDriver: function (edit) {
                return $ihttp.post({
                    method: 1717,
                    parameters: edit
                });
            }
		};

		return service;
	}]);
})();
